class FoundationPropertyOptions {
    constructor(options) {
        this.get = true;
        this.set = true;
        if (options) {
            Object.assign(this, options);
        }
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const foundationPropertyNotFoundMessage = (className, propertyName) => `${className}\'s foundation does not contain the property \"${propertyName}\"`;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const foundationNotFoundMessage = (className) => `${className} does not have a foundation`;
function runIfVerified(target, propertyName, action) {
    if (target._foundation) {
        if (propertyName in target._foundation) {
            return action();
        }
        else {
            throw new Error(foundationPropertyNotFoundMessage(target.localName, propertyName));
        }
    }
    else {
        throw new Error(foundationNotFoundMessage(target.localName));
    }
}
export function FoundationProperty(options) {
    const allOptions = new FoundationPropertyOptions(options);
    return (target, name, descriptor) => {
        let defaultGet;
        let defaultSet;
        const propertyName = name;
        const foundationPropertyName = ((options && options.name) || name).toString();
        if (descriptor) {
            defaultGet = descriptor.get;
            defaultSet = descriptor.set;
            descriptor.configurable = true;
            descriptor.enumerable = true;
            if (allOptions.set) {
                descriptor.set = function (value) {
                    return wireDescriptorSet(this, foundationPropertyName, attributes => {
                        const desc = Object.getOwnPropertyDescriptor(target, foundationPropertyName);
                        desc.set = attributes.set;
                        Reflect.defineProperty(target, propertyName, desc);
                        attributes.set(value);
                    }, defaultSet);
                };
            }
            if (allOptions.get) {
                descriptor.get = function () {
                    return wireDescriptorGet(this, foundationPropertyName, attributes => {
                        const desc = Object.getOwnPropertyDescriptor(target, foundationPropertyName);
                        desc.get = attributes.get;
                        Reflect.defineProperty(target, propertyName, desc);
                        return attributes.get();
                    }, defaultGet);
                };
            }
        }
        else {
            if (allOptions.set || allOptions.get) {
                const attributes = { configurable: true, enumerable: true };
                const get = {
                    get() {
                        const that = this;
                        return wireDescriptorGet(that, foundationPropertyName, attrs => {
                            let setter;
                            // We have to wire the setter here as well
                            if (allOptions.set) {
                                setter = Object.assign({}, set);
                            }
                            Reflect.defineProperty(that, foundationPropertyName, Object.assign(Object.assign({ configurable: true, enumerable: true }, attrs), setter));
                            return attrs.get();
                        });
                    }
                };
                const set = {
                    set(value) {
                        const that = this;
                        return wireDescriptorSet(that, foundationPropertyName, attrs => {
                            let getter;
                            // We have to wire the getter here as well
                            if (allOptions.get) {
                                getter = Object.assign({}, get);
                            }
                            Reflect.defineProperty(that, foundationPropertyName, Object.assign(Object.assign({ configurable: true, enumerable: true }, attrs), getter));
                            attrs.set(value);
                        });
                    }
                };
                if (allOptions.get) {
                    Object.assign(attributes, Object.assign({}, get));
                }
                if (allOptions.set) {
                    Object.assign(attributes, Object.assign({}, set));
                }
                Reflect.defineProperty(target, propertyName, attributes);
            }
        }
    };
}
function setFoundation(target, value, propertyName) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target._foundation[propertyName] = value;
}
function getFoundation(target, propertyName) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return target._foundation[propertyName];
}
function wireDescriptorSet(target, propertyName, wireAction, defaultSet) {
    let attributes;
    if (defaultSet) {
        attributes = {
            set(value) {
                defaultSet.call(target, value);
                setFoundation(target, value, propertyName);
            }
        };
    }
    else {
        attributes = {
            set(value) {
                setFoundation(target, value, propertyName);
            }
        };
    }
    return runIfVerified(target, propertyName, () => wireAction(attributes));
}
function wireDescriptorGet(target, propertyName, wireAction, defaultGet) {
    let attributes;
    if (defaultGet) {
        attributes = {
            get() {
                defaultGet.call(target);
                return getFoundation(target, propertyName);
            }
        };
    }
    else {
        attributes = {
            get() {
                return getFoundation(target, propertyName);
            }
        };
    }
    return runIfVerified(target, propertyName, () => wireAction(attributes));
}
